var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_style"},[(_vm.show)?_c('router-view',{attrs:{"name":"second","v_WeiXin":_vm.v_WeiXin}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }